
	export default {
		data(){
			return {
				desktop: [
					{label: `Windows`, icon: `windows`, url: `https://truefire.com/apps/download-windows`},
					{label: `Mac`, icon: `apple`, url: `https://truefire.com/apps/download-mac`}
				],
				mobile: [
					{label: `App Store`, icon: `apple`, url: `https://itunes.apple.com/us/app/truefire/id690143001?mt=8`},
					{label: `Google Play`, icon: `google-play`, url: `https://play.google.com/store/apps/details?id=com.truefire.android3`},
				],
			}
		},
	}
